export const getSuccessRate = (
  rankLevel: number,
  crimeType: number
): number => {
  let successRate: number;
  let maxSuccessRate: number;
  let multiplier: number;

  switch (crimeType) {
    case 0:
      successRate = 1200; // 12%
      maxSuccessRate = 6725; // 67.25%
      multiplier = 109; // 1.09x
      break;
    case 1:
      successRate = 500; // 5%
      maxSuccessRate = 6395; // 63.95%
      multiplier = 111; // 1.11x
      break;
    case 2:
      successRate = 300; // 3%
      maxSuccessRate = 6369; // 63.69%
      multiplier = 113; // 1.13x
      break;
    case 3:
      successRate = 100; // 1%
      maxSuccessRate = 5758; // 57.58%
      multiplier = 115; // 1.15x
      break;
    default:
      return 0;
  }

  // Calculate success rate based on rank level
  for (let i = 1; i < rankLevel; i++) {
    successRate = (successRate * multiplier) / 100;
  }

  // Cap at maximum success rate
  return Math.min(successRate, maxSuccessRate) / 100;
};
